import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/** Allows `/admin/**` only while the app is in admin portal mode. */
export const adminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.portal() === 'admin') {
    return true;
  }
  return router.createUrlTree(['/employee/dashboard']);
};
